import type { Path, DefaultQueryError } from '@ahm/api-wrappers-core';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { postServiceSuggestionFn } from '@/api/services/post-service-suggestion-fn';

type ServiceSuggestionRequest = {
  service_id: string;
  path: Path[];
  package_size: string;
  package_weight: string | number;
};

type ServiceSuggestionResponse = {
  delivery_type: string;
  is_valid_service: boolean;
};

export const useServiceSuggestionMutation = (
  opts?: UseMutationOptions<
    ServiceSuggestionResponse,
    DefaultQueryError,
    ServiceSuggestionRequest
  >
) =>
  useMutation<
    ServiceSuggestionResponse,
    DefaultQueryError,
    ServiceSuggestionRequest
  >({
    mutationFn: postServiceSuggestionFn,
    ...opts,
  });
